<div class="content-holder">
  <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
    <mat-toolbar-row class="toolbar-row">
      <h1 i18n="Stats Dashboard|Exam Rating Stats Dashboard title@@stats-dashboard-exam-rating-title">Contest
        Participation</h1>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="content page">
    <app-exam-result-stats></app-exam-result-stats>
  </div>
</div>
